
import { getTutorials, setActiveTutorial } from '../../../store/tutorials';
import { tutorialConstants } from '../../../utils/constants';
import { useAppDispatch, useAppSelector } from '../../../store/configureStore';

import Conditional from '../../common/conditional';
import Elevation from './elevation';
import InstructionBox from '../instruction-box';

import classNames from './style.module.scss';
import jeff from '../../../assets/animations/jeff.json';

interface InstructionProps {
	isVisible: boolean;
	title: string;
	message: string;
	onProceed?: () => void;
}

const Instruction = (props: InstructionProps) => {
	const dispatch = useAppDispatch();
	const tutorials = useAppSelector(getTutorials);

	const handleDismissInstruction = () => {
		dispatch(setActiveTutorial(tutorialConstants.MAYBE_LATER));
	};

	const isCompleted = tutorials.activeTutorial === tutorialConstants.COMPLETED;

	return (
		<Conditional isVisible={props.isVisible}>
			<div className={classNames.instructionModal}>
				<Elevation isElevated={props.isVisible}>
					<div className={classNames.instructionModalDashboard}>
						<Conditional isVisible={!isCompleted}>
							<button
								className={classNames.instructionModalClose}
								onClick={handleDismissInstruction}
							>
								<i className="bi bi-x-lg"></i>
							</button>
						</Conditional>

						<InstructionBox
							title={props.title}
							subtitle={props.message}
							isActive
							animation={jeff}
						/>

						<Conditional isVisible={props.onProceed !== undefined}>
							<div
								className={classNames.instructionModalBodyButtons}
								onClick={props.onProceed}
							>
								<button
									type="button"
									className={classNames.instructionModalBodyButtonsItem}
								>
									{isCompleted ? 'Close' : 'Next'}

									<Conditional isVisible={!isCompleted}>
										<i className="bi bi-chevron-right"></i>
									</Conditional>
								</button>
							</div>
						</Conditional>
					</div>
				</Elevation>
			</div>
		</Conditional>
	);
};

export default Instruction;
